
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 15 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#515358","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M13.556 7.724a.586.586 0 00-.587.585v4.85a.793.793 0 01-.796.787H1.977a.797.797 0 01-.804-.786V2.684c0-.438.366-.776.804-.776H5.93a.587.587 0 000-1.172H1.977C.893.736 0 1.6 0 2.684V13.16c0 1.082.893 1.958 1.977 1.958h10.196c1.083 0 1.97-.872 1.97-1.958V8.309a.588.588 0 00-.587-.585"}}),_c('path',{attrs:{"d":"M13.656 2.925l-.328.328-1.593-1.628.317-.313a.438.438 0 01.317-.128h.004c.12 0 .235.044.318.13l.965.983a.447.447 0 010 .628zM8.36 8.22a.428.428 0 01-.186.11l-2.131.655.624-2.214a.492.492 0 01.113-.196l2.902-2.9L11.276 5.3 8.36 8.22zm2.546-5.764L12.5 4.084l-.39.39-1.594-1.629.39-.389zm2.62-1.97A1.622 1.622 0 0012.38 0a1.61 1.61 0 00-1.152.476l-5.27 5.27a1.646 1.646 0 00-.414.707l-.917 3.25a.587.587 0 00.737.718l3.16-.973a1.61 1.61 0 00.67-.404l5.29-5.29c.628-.629.63-1.65.01-2.285l-.966-.982z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/objectMenu/edit.svg